import { ConsumptionRow } from "./consumptionRow";

/**
 * The row a vehicle holds until its data has been read.
 *
 * Reading a fleet takes minutes, so the vehicles are listed with their name and plate straight
 * away and fill in as their answers arrive. That means the row has to exist before anything is
 * known about it — and every figure on it has to be missing rather than zero, or the report would
 * spend those minutes showing a fleet that consumed nothing.
 *
 * @param device - The vehicle.
 * @returns The row, marked as not read yet.
 */
export function pendingConsumptionRow(device: {
  id: string;
  name: string;
  licensePlate: string;
}): ConsumptionRow {
  return {
    id: device.id,
    name: device.name,
    licensePlate: device.licensePlate,
    fuelUsedLiters: null,
    fuelSource: null,
    electricUsedKWh: null,
    filledLiters: null,
    chargedKWh: null,
    chargeDurationHours: null,
    distanceKm: null,
    measuredDistanceKm: null,
    uncoveredDistanceKm: 0,
    fuelRatePer100Km: null,
    electricRatePer100Km: null,
    measuredFrom: null,
    measuredTo: null,
    coverageFrom: null,
    coverageTo: null,
    resetCount: 0,
    fuelDeviationLiters: null,
    fuelDeviationFlagged: false,
    noFillsRecorded: false,
    fillVolumeMissing: false,
    issues: [],
    status: "pending",
  };
}
